import { ComponentFactoryResolver, Directive, Input, OnInit, ViewContainerRef } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { InputComponent } from '../controls/input/input.component';
import { ButtonComponent } from '../controls/button/button.component';
import { DateComponent } from '../controls/date/date.component';
import { LabelComponent } from '../controls/label/label.component';
import { PhonenumberComponent } from '../controls/phonenumber/phonenumber.component';
import { Fields } from 'src/app/shared/models/candidateprofile-genmodel';
import { SelectComponent } from '../controls/select/select.component';
import { AutocompleteComponent } from '../controls/autocomplete/autocomplete.component';
import { InputButtonComponent } from '../controls/input-button/input-button.component';
import { ChipfullwidthComponent } from '../controls/chipfullwidth/chipfullwidth.component';

const componentMapper = {
  0: InputComponent,
  15: DateComponent,
  20: ButtonComponent,
  6: LabelComponent,
  25: PhonenumberComponent,
  11: SelectComponent,
  10: AutocompleteComponent,
  26: InputButtonComponent,
  16: ChipfullwidthComponent,
};
@Directive({
  selector: '[dynamicField]',
  standalone: false,
})
export class DynamicFieldComponent implements OnInit {
  // @Input() field: Fields;
  @Input() field: Fields;
  @Input() group: UntypedFormGroup;
  componentRef: any;
  constructor(
    private resolver: ComponentFactoryResolver,
    private container: ViewContainerRef,
  ) {}
  ngOnInit() {
    const factory = this.resolver.resolveComponentFactory(componentMapper[this.field.type]);
    this.componentRef = this.container.createComponent(factory);
    this.componentRef.instance.field = this.field;
    this.componentRef.instance.group = this.group;
  }
}
